import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';
import { debounce } from 'vue-debounce';
import { $httpChangiRecommends } from '@/core/api';
import SearchBar from './SearchBar.vue';
export default Vue.extend({
    components: { SearchBar },
    data() {
        return {
            isNavSearchActive: false,
            searchText: '',
            searchResult: null,
            searchLoading: false,
        };
    },
    created() {
        if (window.location.pathname.includes('search/')) {
            this.searchText = this.query;
        }
    },
    watch: {
        query(currentQuery) {
            if (currentQuery) {
                this.searchText = currentQuery;
            }
        },
    },
    computed: {
        ...mapState('searchModule', ['query', 'recentSearches']),
    },
    methods: {
        ...mapMutations('searchModule', ['setQuery', 'clearRecentSearches']),
        clearSearch() {
            this.searchResult = null;
            this.searchText = '';
            this.closeNavSearch();
        },
        goToSearchPage() {
            const path = `/search/${encodeURIComponent(this.searchText)}`;
            if (this.$route.fullPath !== path) {
                this.$router.push(path);
            }
        },
        openNavSearch() {
            this.isNavSearchActive = true;
        },
        closeNavSearch() {
            this.isNavSearchActive = false;
        },
        // Copy of your header search logic (kept minimal)
        searchTextChanged: debounce(function (value) {
            this.searchLoading = true;
            if (!value) {
                this.searchResult = null;
                this.searchLoading = false;
                return;
            }
            if (value.length < 3) {
                this.searchLoading = false;
                return;
            }
            this.setQuery(value);
            $httpChangiRecommends.api
                .ChangiRecommendsProductSearch({
                query: encodeURIComponent(value),
                autocompleteOnly: true,
            })
                .then((resp) => {
                this.searchResult = resp;
            })
                .catch((error) => {
                this.searchResult = { data: [], message: error.message };
                this.searchLoading = false;
            })
                .finally(() => {
                this.searchLoading = false;
            });
        }, 400),
    },
});
